import WebServiceRequest from '../Api/WebServiceRequest'

class createFaq extends WebServiceRequest {
    constructor (context) {
        super(context)

        super.setTag('Faq/Create')
    }
    setParams(data){
        super.setRequestParamDataObj(data)
    }
}
class updateFaq extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('Faq/Update');
    }
    setParams(data){
        super.setRequestParamDataObj(data);
    }
}
class getAllFaq extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('Faq/GetAll')
    }
    setParams(data){
        super.setRequestParamDataObj(data)
    }
}
class deleteFaq extends WebServiceRequest {
    constructor (context) {
        super(context)
    }
    setId(id){
        super.setTag('Faq/Delete?id='+id)
    }
}
export {
    createFaq,
    updateFaq,
    getAllFaq,
    deleteFaq

};
